import { FC, ReactNode } from "react";

import { Alert, Grid, styled, Typography, useTheme } from "@mui/material";
import type { Icon } from "@phosphor-icons/react";
import { AnchorHoverLink } from "../ui/common";

const WelcomeTitle = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "18px",
  marginBottom: "20px",
});

const InfoRow = styled("div")`
  padding-top: 10px;
  padding-bottom: 10px;
`;
interface BaseWelcomeMessageProps {
  icon: Icon;
  title: string;
  supportDocsLink?: string;
  children?: ReactNode;
}

const BaseWelcomeMessage: FC<BaseWelcomeMessageProps> = ({ icon: Icon, title, children, supportDocsLink }) => {
  const theme = useTheme();

  return (
    <Grid container sx={{ mt: 2 }}>
      <Grid size={6}>
        <Alert severity="info" icon={false} sx={{ boxShadow: "none" }}>
          <WelcomeTitle data-cy="welcome-title">
            <Icon size="18px" weight="fill" color={theme.palette.text50.main} style={{ marginRight: "10px" }} />
            <Typography sx={{ color: "text50.main" }}>{title}</Typography>
          </WelcomeTitle>
          {children}
          {supportDocsLink ? (
            <InfoRow>
              Support Documentation is available
              <AnchorHoverLink href={supportDocsLink} target="_blank">
                here
              </AnchorHoverLink>
            </InfoRow>
          ) : null}
        </Alert>
      </Grid>
    </Grid>
  );
};

export { BaseWelcomeMessage };
